import { render, staticRenderFns } from "./idcard.vue?vue&type=template&id=905d1538&"
import script from "./idcard.vue?vue&type=script&lang=js&"
export * from "./idcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports